import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {  isArray } from 'lodash';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { t } from '~/helpers';
import api from '~/services/api';

import { ContainerForm } from './styles';

export default function MyForm({ data, reference, close }) {
  const [isLoading, setIsLoading] = useState(false);
 
  const handleSubmit = React.useCallback(async (param) => {
  //async function handleSubmit(param) {
    try {      
      await api.delete(`recebimento/${data.desc_codigo}`);
      toast.success(t('s.geral.sucessoalteracao'));
      await close();
    } catch (err) {
      if (isArray(err)) {
        err.map((e) => toast.error(e));
      }
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });
        reference.current.setErrors(validationErrors);
      }
    }
  },[data]);
  
  useEffect(() => {
    let mounted = true;
    if (mounted) {     
    }
    return function cleanup() {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    reference.current.setData(data);   
  }, []);

  return (
    <>
      <ContainerForm ref={reference} initialData={data} onSubmit={handleSubmit}>
        <div>
          {`Confirma excluir o recebimento da NF ${data.desc_nf}?`} 
        </div>
      </ContainerForm>
    </>
  );
}

MyForm.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
};
